import { useState, useContext, useEffect, useMemo, useRef } from "react";
import { Box, Button, DialogActions, DialogContent, DialogTitle, IconButton, useMediaQuery } from "@mui/material";
import StoreContext from "./../Componentes/Store/Context";
import { MDBIcon } from "mdb-react-ui-kit";
import { Col, Row, Label, Container } from "reactstrap";
import moment from "moment";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { MaterialReactTable, MRT_EditActionButtons as MrtEditActionButtons } from "material-react-table";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AddBoxIcon from "@mui/icons-material/AddBox";
import CachedIcon from "@mui/icons-material/Cached";
import EditIcon from "@mui/icons-material/Edit";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import SearchIcon from "@mui/icons-material/Search";
import { CPBS, imgURLocalImage, put_facturado_orden } from "../Componentes/Services";
import { BARCODE_IMAGE } from "./Image";
import { STATES_DC_COMPRA, STATES_MOV_MOVIMIENTO, STATES_RE_RECUENTO } from "./States";
import {
  COLUMNS_GAS_GASTOS,
  COLUMNS_LISTA_ORDENES_NORMAL,
  COLUMNS_LISTA_ORDENES,
  COLUMNS_ORDENES_DETALLE_RESTAURANTE,
  COLUMNS_CREDITOS_PAGO,
  COLUMNS_CREDITOS,
  COLUMNS_LISTA_CREDITOS_PAGO,
  COLUMNS_LISTA_CREDITOS_DETALLE,
  COLUMNS_LISTA_CREDITOS,
  COLUMNS_RE_RECUENTO_DETALLE,
  COLUMNS_LISTA_COTIZACION,
  COLUMNS_LISTA_FPAGO,
  COLUMNS_LISTA_ANULACION,
  COLUMNS_DC_COMPRA_DETALLE,
  COLUMNS_RE_CUENTO,
  COLUMNS_DC_COMPRA,
  COLUMNS_ARTICULOS,
  COLUMNS_AP_APARTADO,
  COLUMNS_CATEGORIAS,
  COLUMNS_USUARIOS,
  COLUMNS_MARCAS,
  COLUMNS_PROVEEDORES,
  COLUMNS_CLIENTES,
  COLUMNS_BODEGA,
  COLUMNS_FAC_FACTURA_DETALLE,
  COLUMNS_COT_COTIZACION,
  COLUMNS_LISTA_CLIENTE,
  COLUMNS_LISTA_ITEMS,
  COLUMNS_COTD_COOTIZACION_DETALLE,
  COLUMNS_GARANTIA,
  COLUMNS_DESCUENTO,
  COLUMNS_PUBLICIDAD,
  COLUMNS_EXISTENCIA_INVENTARIO,
  COLUMNS_TRAZABILIDAD,
  COLUMNS_MOV_MOVIMIENTO,
  COLUMNS_MOVD_MOVIMIENTO_DETALLE,
  COLUMNS_LISTA_ITEMS_BODEGA,
  COLUMNS_CLIENTES_HISTORIAL,
  COLUMNS_SALIDA_VENTA,
  COLUMNS_ENTRADA_INVENTARIO,
  COLUMNS_ENTRADA_FACTURA_COMPRA,
  COLUMNS_SERIES,
  COLUMNS_MESAS,
  COLUMNS_CPBS,
  COLUMNS_AREAS,
  COLUMNS_CPBS_MOBILE,
} from "../Componentes/DatatableColumns";

import { CsvDownloadIcon, EmptyRecordsIcon, IconSearch, ImageIcon, PencilIcon, PlusIcon, PrintIcon, ProcessDocumentIcon, RefreshIcon, ToggleIcon, Trash2Icon } from "./www/Icons";

/* Estilos reutilizables para los IconButton (mismo look que la pantalla de mesas) */
const actionBtnSx = {
  color: "var(--rt-muted, #64748b)",
  borderRadius: "8px",
  padding: "6px",
  "&:hover": {
    backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
    color: "var(--rt-primary, #14795a)",
  },
};
const deleteBtnSx = {
  color: "var(--rt-muted, #64748b)",
  borderRadius: "8px",
  padding: "6px",
  "&:hover": {
    backgroundColor: "rgba(192,57,43,0.1)",
    color: "var(--rt-danger, #c0392b)",
  },
};
const toolbarBtnSx = {
  color: "var(--rt-muted, #64748b)",
  borderRadius: "8px",
  padding: "8px",
  "&:hover": {
    backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
    color: "var(--rt-primary, #14795a)",
  },
};
function DATATABLE_PUBLICIDAD({ setImages, datapublicidad, setFormPublicidad, fetchPublicidad, setBasicModal, setSrcImage, setModalImageTooltip, setError, setBasicModalDelete }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(datapublicidad.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [datapublicidad, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "img_id") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enableSorting={true}
      enablePagination={true}
      enableFilters={false}
      enableFullScreenToggle={false}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableToolbarInternalActions={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_PUBLICIDAD(setSrcImage, setModalImageTooltip)}
      data={datapublicidad}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyProps={{
        sx: () => ({
          "& tr:nth-of-type(odd)": {},
        }),
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-delete-articulos mx-auto d-flex">
            <IconButton
              color="error"
              className="mx-auto"
              onClick={() => {
                setBasicModalDelete(true);
                setFormPublicidad(row.original);
              }}
            >
              <Trash2Icon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModal(true);
              setImages([]);
              setFormPublicidad({
                img_id: "",
                img_name: "",
                img_sts: "",
                img_dataurl: "",
                img_type: "",
              });
              setError("");
            }}
          >
            Agregar publicidad
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchPublicidad()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_GARANTIA({ dataGarantia, setBasicModalDelete, setFormGarantia, setBasicModal, setBasicModalEdit, setError, fetchGarantia, isLoadingG }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataGarantia.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataGarantia, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ isLoading: isLoadingG, pagination }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "gr_name") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_GARANTIA}
      data={dataGarantia}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        if (row.original.gr_id !== "1") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                sx={deleteBtnSx}
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormGarantia(row.original);
                  setError("");
                }}
              >
                <Trash2Icon />
              </IconButton>
              <IconButton
                sx={actionBtnSx}
                onClick={() => {
                  setBasicModal(true);
                  setFormGarantia(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <PencilIcon />
              </IconButton>
            </Box>
          );
        } else {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                sx={actionBtnSx}
                onClick={() => {
                  setBasicModal(true);
                  setFormGarantia(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <PencilIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModal(true);
              setFormGarantia({
                gr_id: "",
                gr_name: "",
                gr_descripcion: "",
                gr_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            Agregar garantía
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchGarantia()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_AREAS({ dataAreas, setBasicModalDelete, setFormAreas, setBasicModal, setBasicModalEdit, setError, fetchAreas, isLoadingG }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataAreas.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataAreas, pagination.pageSize, pagination.pageIndex]);

  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ isLoading: isLoadingG, pagination }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "res_id") {
          return {
            sx: {
              fontWeight: 700,
              color: "var(--rt-text, #1e293b)",
            },
          };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_AREAS}
      data={dataAreas}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        if (row.original.gr_id !== "1") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                sx={deleteBtnSx}
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormAreas(row.original);
                  setError("");
                }}
              >
                <Trash2Icon />
              </IconButton>
              <IconButton
                sx={actionBtnSx}
                onClick={() => {
                  setBasicModal(true);
                  setFormAreas(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <PencilIcon />
              </IconButton>
            </Box>
          );
        } else {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                sx={actionBtnSx}
                onClick={() => {
                  setBasicModal(true);
                  setFormAreas(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <PencilIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      renderTopToolbarCustomActions={() => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "4px",
          }}
        >
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",

              "&:hover": {
                backgroundColor: "var(--rt-primary-dark, #0f5f47)",
              },
            }}
            onClick={() => {
              setBasicModal(true);
              setFormAreas({
                ar_id: "",
                ar_desc: "",
                ar_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            Agregar Areas
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchAreas()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_MESAS({ dataRestaurante, setBasicModalDelete, setFormRestaurante, setBasicModal, setBasicModalEdit, setError, fetchRestaurante, isLoadingG, set_mesa_inactiva }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataRestaurante.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataRestaurante, pagination.pageSize, pagination.pageIndex]);

  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ isLoading: isLoadingG, pagination }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "res_id") {
          return {
            sx: {
              fontWeight: 700,
              color: "var(--rt-text, #1e293b)",
            },
          };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_MESAS}
      data={dataRestaurante}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        if (row.original.gr_id !== "1") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                sx={deleteBtnSx}
                onClick={() => {
                  set_mesa_inactiva(row.original);
                  setError("");
                }}
              >
                <ToggleIcon active={row.original.res_active} />
              </IconButton>
              <IconButton
                sx={deleteBtnSx}
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormRestaurante(row.original);
                  setError("");
                }}
              >
                <Trash2Icon />
              </IconButton>
              <IconButton
                sx={actionBtnSx}
                onClick={() => {
                  setBasicModal(true);
                  setFormRestaurante(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <PencilIcon />
              </IconButton>
            </Box>
          );
        } else {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                sx={actionBtnSx}
                onClick={() => {
                  setBasicModal(true);
                  setFormRestaurante(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <PencilIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      renderTopToolbarCustomActions={() => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "4px",
          }}
        >
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",

              "&:hover": {
                backgroundColor: "var(--rt-primary-dark, #0f5f47)",
              },
            }}
            onClick={() => {
              setBasicModal(true);
              setFormRestaurante({
                res_id: "",
                res_nombre: "",
                res_area: "",
                res_active: "",
                res_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            Agregar Mesa
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchRestaurante()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_TRAZABILIDAD({ dataTrazabilidad, setTabTrazabilidadDetail, fetchTrazabilidadDetallado }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataTrazabilidad.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataTrazabilidad, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="semantic"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_TRAZABILIDAD}
      data={dataTrazabilidad}
      muiTableBodyRowProps={({ row }) => {
        if (row.original.art_linea_roja !== "0") {
          return {
            sx: {
              backgroundColor: row.original.inv_qty >= row.original.art_linea_roja ? "#f0f0f0" : "#fbd2d2",
            },
          };
        }
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "art_upc") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-deletes">
            {
              <IconButton
                onClick={() => {
                  fetchTrazabilidadDetallado({
                    art_id: row.original.art_id,
                    art_upc: row.original.art_upc,
                    art_descripcion: row.original.art_descripcion,
                  });
                  setTabTrazabilidadDetail(true);
                }}
              >
                <SearchIcon />
              </IconButton>
            }
          </Box>
        );
      }}
    />
  );
}
function DATATABLE_CPBS({ selectItemCPBS, codigo }) {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: window.innerHeight >= 1000 ? 20 : 10,
  });

  const dataCPBS = useMemo(() => {
    if (!codigo) return CPBS;

    const seleccionado = CPBS.find((item) => String(item.codigo) === String(codigo));

    if (!seleccionado) return CPBS;

    return [seleccionado, ...CPBS.filter((item) => String(item.codigo) !== String(codigo))];
  }, [codigo]);

  useEffect(() => {
    if (codigo) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: 0,
      }));
    }
  }, [codigo]);

  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "codigo") {
          return {
            sx: {
              fontWeight: 700,
              color: "var(--rt-text, #1e293b)",
            },
          };
        }

        return {};
      }}
      muiTableBodyRowProps={({ row }) => {
        const seleccionado = String(row.original.codigo) === String(codigo);

        return {
          sx: {
            backgroundColor: seleccionado ? "#dff4e8 !important" : undefined,

            "& td": {
              backgroundColor: seleccionado ? "#dff4e8 !important" : undefined,
              borderTop: seleccionado ? "1px solid #8fd0aa" : undefined,
              borderBottom: seleccionado ? "1px solid #8fd0aa" : undefined,
            },

            "&:hover td": {
              backgroundColor: seleccionado ? "#d3eedf !important" : undefined,
            },
          },
        };
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      enableSorting={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>

          <div className="empty-records-title">No hay registros que mostrar</div>

          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={window.innerWidth <= 611 ? COLUMNS_CPBS_MOBILE() : COLUMNS_CPBS()}
      data={dataCPBS}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        const seleccionado = String(row.original.codigo) === String(codigo);
        return (
          <Box className="w-90px mx-auto">
            {seleccionado ? (
              <span className="cpbs-selected-badge">
                <span>✓</span>
                SELECCIONADO
              </span>
            ) : (
              <IconButton
                color="error"
                onClick={() => {
                  selectItemCPBS(row.original);
                }}
              >
                <PlusIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
    />
  );
}
function DATATABLE_CLIENTES({ dataRetencion, dataClientes, setBasicModalDelete, setFormClientes, setBasicModal, setBasicModalEdit, setError, fetchCliente, isLoadingC }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataClientes.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataClientes, pagination.pageSize, pagination.pageIndex]);

  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ isLoading: isLoadingC, pagination }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "cli_nombre") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      enableSorting={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_CLIENTES({ dataRetencion })}
      data={dataClientes}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        if (row.original.cli_id !== "16") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                color="error"
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormClientes(row.original);
                  setError("");
                }}
              >
                <Trash2Icon />
              </IconButton>
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setFormClientes(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <PencilIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModal(true);
              setFormClientes({
                cli_id: "",
                cli_suc: "",
                cli_sts: "",
                cli_nombre: "",
                cli_direccion: "",
                cli_telefono: "",
                cli_telefono2: "",
                cli_ruc: "",
                cli_dv: "",
                cli_limitc: "",
                cli_credito: "",
                cli_email: "",
                re_id: "",
                re_desc: "",
                re_porc: "",
                re_codigo: "",
                cli_exento: "0",
                cli_tipo_clienteFE: "02",
              });
              setBasicModalEdit(false);
              setError("");
            }}
          >
            Agregar cliente
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchCliente()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_USUARIOS({ dataUsuarios, setFormUsuarios, setBasicModal, setBasicModalEdit, setError, fetchUsuarios, isLoading }) {
  return (
    <MaterialReactTable
      initialState={{
        pagination: { pageSize: window.innerHeight >= 1000 ? 30 : 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "usr_nombre") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoading }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_USUARIOS}
      data={dataUsuarios}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              sx={actionBtnSx}
              onClick={() => {
                setBasicModal(true);
                setFormUsuarios(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <PencilIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchUsuarios()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_COTIZACION({ dataCotizacion, onClickDeleteCotizacion_sts, setBasicModalEdit, setBasicModal, setFormCotCotizacion, fetchCotdDetalle, setFormClientes, setPrintI, onClickNuevaCotizacion, fetch_cot_cotizacion, dataRetencion }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataCotizacion.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataCotizacion, pagination.pageSize, pagination.pageIndex]);

  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{ showRowsPerPage: false }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "cli_nombre" || column.id === "cot_id") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      muiTopToolbarProps={{
        className: "mrt-toolbar-mobile",
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_COT_COTIZACION}
      data={dataCotizacion}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto d-flex">
            <IconButton
              sx={actionBtnSx}
              onClick={() => {
                setBasicModalEdit(true);
                setBasicModal(true);
                setFormCotCotizacion({
                  cot_id: row.original.cot_id,
                  cot_identificador: row.original.cot_identificador,
                  cot_cliente: row.original.cot_cliente,
                  cot_nombre: row.original.cli_nombre,
                  cot_fecha: moment(row.original.cot_fecha, "DD-MM-YYYY").format("YYYY-MM-DD"),
                  cot_vendedor: row.original.cot_vendedor,
                  cot_status: row.original.cot_status,
                  cot_garantia: row.original.cot_garantia,
                  cot_garantia_name: row.original.cot_garantia_name,
                  cot_descripcion: row.original.cot_descripcion,
                  cot_validez: row.original.cot_validez,
                });
                fetchCotdDetalle({
                  print: false,
                  cotd_identificador: row.original.cot_identificador,
                  formCotizacion: [],
                });
                setFormClientes({
                  cli_id: row.original.cot_cliente,
                  cli_nombre: row.original.cli_nombre,
                  cli_ruc: row.original.cli_ruc,
                  cli_direccion: row.original.cli_direccion,
                  cli_telefono: row.original.cli_telefono,
                  cli_telefono2: row.original.cli_telefono2,
                  cli_dv: row.original.cli_dv,
                  cli_email: row.original.cli_email,
                  cli_limitc: row.original.cli_limitc,
                  cli_credito: row.original.cli_credito,
                  cli_exento: row.original.cli_exento,
                  cli_tipo_clienteFE: row.original.cli_tipo_clienteFE,
                  cli_tipoContribuyente: row.original.cli_tipoContribuyente,
                  cli_retencion: row.original.cli_retencion,
                  cli_suc: row.original.cli_suc,
                  cli_sts: row.original.cli_sts,
                  re_id: row.original.cli_retencion,
                  re_desc: dataRetencion.find((item) => item.re_id === row.original.cli_retencion)?.re_desc ?? "",
                });
              }}
            >
              <PencilIcon />
            </IconButton>
            <IconButton
              sx={actionBtnSx}
              onClick={() =>
                onClickDeleteCotizacion_sts({
                  cot_id: row.original.cot_id,
                  cot_status: 0,
                })
              }
            >
              <Trash2Icon />
            </IconButton>
            <IconButton
              sx={actionBtnSx}
              onClick={() => {
                setPrintI(true);
                setFormCotCotizacion({
                  cot_id: row.original.cot_id,
                  cot_identificador: row.original.cot_identificador,
                  cot_cliente: row.original.cot_cliente,
                  cot_nombre: row.original.cli_nombre,
                  cli_ruc: row.original.cli_ruc,
                  cli_dv: row.original.cli_dv,
                  cli_telefono: row.original.cli_telefono,
                  cli_exento: row.original.cli_exento,
                  cli_tipo_clienteFE: row.original.cli_tipo_clienteFE,
                  cot_fecha: moment(row.original.cot_fecha, "DD-MM-YYYY").format("YYYY-MM-DD"),
                  cot_vendedor: row.original.cot_vendedor,
                  cot_status: row.original.cot_status,
                  cot_descripcion: row.original.cot_descripcion,
                  cot_garantia: row.original.cot_garantia,
                  cot_garantia_name: row.original.cot_garantia_name,
                  cot_vendedor_name: row.original.usr_nombre,
                  cot_validez: row.original.cot_validez,
                });
                fetchCotdDetalle({
                  print: true,
                  cotd_identificador: row.original.cot_identificador,
                  formCotizacion: {
                    cot_id: row.original.cot_id,
                    cot_identificador: row.original.cot_identificador,
                    cot_cliente: row.original.cot_cliente,
                    cot_nombre: row.original.cli_nombre,
                    cli_ruc: row.original.cli_ruc,
                    cli_exento: row.original.cli_exento,
                    cli_tipo_clienteFE: row.original.cli_tipo_clienteFE,
                    cli_dv: row.original.cli_dv,
                    cli_telefono: row.original.cli_telefono,
                    cot_fecha: row.original.cot_fecha,
                    cot_vendedor: row.original.cot_vendedor,
                    cot_status: row.original.cot_status,
                    cot_descripcion: row.original.cot_descripcion,
                    cot_garantia: row.original.cot_garantia,
                    cot_garantia_name: row.original.cot_garantia_name,
                    cot_vendedor_name: row.original.usr_nombre,
                    cot_validez: row.original.cot_validez,
                  },
                });
              }}
            >
              <PrintIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              onClickNuevaCotizacion();
            }}
          >
            Agregar cotizacion
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetch_cot_cotizacion()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_COTIZACION_DETALLE({ deleteRow, OBJCotizacionDetalle, handleSaveRow, usr_precio, viewImage }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(OBJCotizacionDetalle.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [OBJCotizacionDetalle, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      onPaginationChange={setPagination}
      state={{
        pagination,
        columnVisibility: {
          cotd_cantidad: window.innerWidth > 660,
          cotd_precio: window.innerWidth > 660,
          cotd_descuento: window.innerWidth > 660,
          art_descripcion: window.innerWidth > 660,
          cotd_descuento_number: false,
        },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 140,
          minSize: 140,
          maxSize: 140,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "art_upc" || column.id === "cotd_total") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={false}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      onEditingRowSave={handleSaveRow}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_COTD_COOTIZACION_DETALLE(usr_precio)}
      data={OBJCotizacionDetalle}
      muiSearchTextFieldProps={{ placeholder: "Buscar" }}
      renderRowActions={({ row, table }) => {
        return (
          <Box className="cot-row-actions">
            <IconButton className="cot-action-btn cot-action-edit" title="Editar artículo" onClick={() => table.setEditingRow(row)}>
              <PencilIcon />
            </IconButton>
            <IconButton className="cot-action-btn cot-action-delete" title="Eliminar artículo" onClick={() => deleteRow(row)}>
              <Trash2Icon />
            </IconButton>
            {row.original.art_img === "1" && (
              <IconButton className="cot-action-btn cot-action-image" title="Ver imagen del artículo" onClick={() => viewImage({ row: row.original })}>
                <ImageIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
    />
  );
}
function DATATABLE_LISTA_CLIENTE({ dataCliente, dataRetencion, selectCliente, setTabClientes }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataCliente.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataCliente, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "cli_nombre") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      enableSorting={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_LISTA_CLIENTE({ dataRetencion })}
      data={dataCliente}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                selectCliente(row);
                setTabClientes(false);
              }}
            >
              <PlusIcon />
            </IconButton>
          </Box>
        );
      }}
    />
  );
}
function DATATABLE_LISTA_ITEMS({ select_detail_articulo, dataItems, selectItem, setTabItems }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  const { usr_a_costo } = useContext(StoreContext);
  useEffect(() => {
    const totalPages = Math.ceil(dataItems.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataItems, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{
        pagination,
        columnVisibility: {
          art_costo: usr_a_costo === "1" ? true : false,
        },
      }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "art_upc") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      enableSorting={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_LISTA_ITEMS()}
      data={dataItems}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                selectItem(row.original.art_upc);
                setTabItems(false);
              }}
            >
              <PlusIcon />
            </IconButton>
            <IconButton
              color="error"
              onClick={() => {
                select_detail_articulo({ row: row.original });
              }}
            >
              <IconSearch />
            </IconButton>
          </Box>
        );
      }}
    />
  );
}
function DATATABLE_DC_COMPRA({ dataCompra, setFormCompraDelete, setBasicModalDelete, setBasicModalEdit, setBasicModal, setFormCompra, fetchDCCompraDetalle, setFormDropDownProveedor, setPrintI, setFormProcess, setBasicModalProcesar, fetchDCCompra, setFormCompraDetalle, setOBJCompraDetalle }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataCompra.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataCompra, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 160,
          minSize: 160,
          maxSize: 160,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "dc_docn" || column.id === "dcd_total") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_DC_COMPRA()}
      data={dataCompra}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="mx-auto d-flex">
            {row.original.dc_procesado === "0" ? (
              <IconButton
                color="error"
                onClick={() => {
                  setFormCompraDelete({ dc_id: row.original.dc_id, dc_status: 0 });
                  setBasicModalDelete(true);
                }}
              >
                <Trash2Icon />
              </IconButton>
            ) : null}

            {row.original.dc_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setBasicModalEdit(true);
                  setBasicModal(true);
                  setFormCompra({
                    dc_id: row.original.dc_id,
                    dc_docn: row.original.dc_docn,
                    dc_identificador: row.original.dc_identificador,
                    dc_proveedor: row.original.dc_proveedor,
                    prov_proveedor: row.original.prov_proveedor,
                    dc_procesado: row.original.dc_procesado,
                    dcd_total: row.dcd_total,
                    dc_fecha_procesado: row.original.dc_fecha_procesado,
                    dc_fecha: row.original.dc_fecha,
                    dc_descripcion: row.original.dc_descripcion,
                    dc_status: row.original.dc_status,
                    bod_id: row.original.bod_id,
                    bod_nombre: row.original.bod_nombre,
                  });
                  fetchDCCompraDetalle(row.original.dc_identificador);
                  setBasicModalEdit(true);
                  setFormCompraDetalle({
                    dcd_id: "",
                    dcd_articulo: "",
                    dcd_precio: "",
                    dcd_cantidad: "1",
                    dcd_itbms: "",
                    dcd_descuento: "",
                    dcd_total: "",
                    dcd_descuento_number: "",
                    art_descripcion: "",
                    art_upc: "",
                    art_itbm_cod_c: "",
                    art_itbm_compra: "",
                    art_serie: "",
                  });
                  setFormDropDownProveedor({
                    prov_id: row.original.dc_proveedor,
                    prov_nombre: row.original.prov_proveedor,
                    bod_id: row.original.bod_id,
                    bod_nombre: row.original.bod_nombre,
                  });
                }}
              >
                <PencilIcon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setPrintI(true);
                setFormCompra({
                  dc_id: row.original.dc_id,
                  dc_docn: row.original.dc_docn,
                  dc_identificador: row.original.dc_identificador,
                  dc_proveedor: row.original.dc_proveedor,
                  prov_proveedor: row.original.prov_proveedor,
                  dc_procesado: row.original.dc_procesado,
                  dcd_total: row.dcd_total,
                  dc_fecha_procesado: row.original.dc_fecha_procesado,
                  dc_fecha: row.original.dc_fecha,
                  dc_descripcion: row.original.dc_descripcion,
                  dc_status: row.original.dc_status,
                  bod_id: row.original.bod_id,
                  bod_nombre: row.original.bod_nombre,
                });
                fetchDCCompraDetalle(row.original.dc_identificador);
              }}
            >
              <PrintIcon />
            </IconButton>
            {row.original.dc_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setFormProcess({
                    dcd_identificador: row.original.dc_identificador,
                    dc_proveedor: row.original.dc_proveedor,
                    dc_id: row.original.dc_id,
                    bod_id: row.original.bod_id,
                  });
                  setBasicModalProcesar(true);
                }}
              >
                <ProcessDocumentIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModalEdit(false);
              setBasicModal(true);
              setFormDropDownProveedor({
                prov_id: "",
                prov_nombre: "",
                bod_id: "",
                bod_nombre: "",
              });
              setFormCompra(STATES_DC_COMPRA({ staneName: "formCompra" }));
              setFormCompraDetalle(STATES_DC_COMPRA({ staneName: "formCompraDetalle" }));
              setOBJCompraDetalle([]);
            }}
          >
            Agregar factura
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchDCCompra()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
const FACX_DT = {
  chrome: "#1f2a44",
  chromeInk: "#eef2fb",
  ink: "#1e2534",
  line: "#e4e8ef",
  surface: "#ffffff",
  zebra: "#f6f8fb",
  greenSoft: "#e8f6ee",
};
function DATATABLE_FACTURA({ deleteRow, handleSaveRow, dataFacturaDetalle, enableTab, usr_precio, isRestaurant, dataDescuento, setDescuento, usr_perfil }) {
  const isMobile = useMediaQuery("(max-width:611px)");
  const tableContainerRef = useRef(null);
  const previousLengthRef = useRef(dataFacturaDetalle.length);
  useEffect(() => {
    const previousLength = previousLengthRef.current;
    const currentLength = dataFacturaDetalle.length;

    // Solo hacer scroll si se agregó un artículo
    if (currentLength > previousLength) {
      requestAnimationFrame(() => {
        if (tableContainerRef.current) {
          tableContainerRef.current.scrollTo({
            top: tableContainerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
      });
    }

    previousLengthRef.current = currentLength;
  }, [dataFacturaDetalle.length]);
  return (
    <MaterialReactTable
      state={{
        columnVisibility: isRestaurant
          ? {
              detalle_pos: true,
              art_descripcion: false,
              art_upc: false,
              fcd_precio: false,
              fcd_cantidad: false,
              fcd_descuento: false,
              fcd_descuento_number: false,
              fcd_itbms: false,
              fcd_total: false,
            }
          : {
              art_descripcion: !isMobile,
              fcd_precio: !isMobile,
              fcd_cantidad: !isMobile,
              fcd_descuento_number: false,
              art_upc: false,
            },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: isRestaurant ? 0 : 82,
          maxSize: isRestaurant ? 0 : 82,
          minSize: isRestaurant ? 0 : 82,
          muiTableBodyCellProps: {
            sx: {
              display: isRestaurant || isMobile ? "none" : "flex",
              width: isRestaurant ? "0px" : "82px",
              minWidth: isRestaurant ? "0px" : "82px",
              maxWidth: isRestaurant ? "0px" : "82px",
              padding: isRestaurant ? "0 !important" : "8px 6px !important",
              justifyContent: "center",
              alignItems: "center",
            },
          },
          muiTableHeadCellProps: {
            sx: {
              display: isRestaurant || isMobile ? "none" : "flex",
              width: isRestaurant ? "0px" : "82px",
              minWidth: isRestaurant ? "0px" : "82px",
              maxWidth: isRestaurant ? "0px" : "82px",
              padding: isRestaurant ? "0 !important" : undefined,
              justifyContent: "center",
              textAlign: "center",
            },
          },
        },
      }}
      layoutMode={isRestaurant ? "semantic" : "grid"}
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={false}
      enableTopToolbar={false}
      enableRowActions={!isMobile && !isRestaurant}
      positionActionsColumn="last"
      enablePagination={false}
      enableSorting={false}
      enableFilters={false}
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyProps={{
        sx: {
          width: "100%",
        },
      }}
      muiTableProps={{
        sx: {
          width: "100%",
          tableLayout: isRestaurant ? "fixed" : "auto",
        },
      }}
      muiTableContainerProps={{
        ref: tableContainerRef,
        className: "facx-table-container",
        sx: {
          flex: 1,
          minHeight: 0,
          height: "100%",
          maxHeight: "none",
          overflowY: "auto",
          overflowX: isRestaurant ? "hidden" : isMobile ? "hidden" : "auto",
          width: "100%",
        },
      }}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
        size: "small",
        sx: {
          "& .MuiInputBase-root": {
            fontSize: "13px",
            borderRadius: "8px",
          },
        },
      }}
      renderEmptyRowsFallback={() => (
        <Container fluid>
          <Row>
            <Col xs={12} className="facx-empty">
              <MDBIcon fas icon="shopping-cart" />
              <span>No hay artículos agregados</span>
            </Col>
          </Row>
        </Container>
      )}
      columns={COLUMNS_FAC_FACTURA_DETALLE(usr_precio, deleteRow, isRestaurant)}
      onEditingRowSave={handleSaveRow}
      data={enableTab ? [] : Array.isArray(dataFacturaDetalle) ? dataFacturaDetalle : []}
      muiTablePaperProps={{
        elevation: 0,
        className: "facx-dt-paper",
        sx: {
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          borderRadius: window.innerWidth <= 611 ? "0px" : "12px",
          border: window.innerWidth <= 611 ? "none" : `1px solid ${FACX_DT.line}`,
          overflow: "hidden",
          boxShadow: window.innerWidth <= 611 ? "none" : "0 1px 3px rgba(16,24,40,0.06)",
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          minHeight: "44px !important",
          padding: isMobile ? "8px 7px !important" : "10px 12px !important",
          backgroundColor: FACX_DT.chrome,
          color: FACX_DT.chromeInk,
          fontWeight: 800,
          fontSize: isMobile ? "10px !important" : "12px !important",
          letterSpacing: "0.035em",
          textTransform: "uppercase",
          borderBottom: `1px solid ${FACX_DT.line}`,
          "& .Mui-TableHeadCell-Content": {
            justifyContent: "inherit",
          },
          "& .Mui-TableHeadCell-Content-Labels": {
            fontSize: "inherit !important",
            fontWeight: "inherit !important",
          },
          "& svg": {
            color: FACX_DT.chromeInk,
          },
        },
      }}
      muiTableHeadProps={{
        sx: {
          display: isRestaurant ? "none" : undefined,
        },
      }}
      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <DialogTitle
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              color: "#223150",
            }}
          >
            Editar artículo
          </DialogTitle>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              "& .MuiInputBase-input": {
                fontSize: "14px",
              },
              "& .MuiInputLabel-root": {
                fontSize: "13px",
              },
            }}
          >
            {internalEditComponents}
          </DialogContent>
          <DialogActions>
            <MrtEditActionButtons variant="icon" table={table} row={row} />
          </DialogActions>
        </>
      )}
      renderRowActions={({ row, table }) => {
        if (isMobile || isRestaurant) {
          return null;
        }

        return (
          <Box className="d-flex facx-dt-actions">
            <IconButton className="facx-dt-edit" onClick={() => table.setEditingRow(row)}>
              <PencilIcon />
            </IconButton>

            <IconButton className="facx-dt-del" onClick={() => deleteRow(row)}>
              <Trash2Icon />
            </IconButton>
          </Box>
        );
      }}
      muiTableBodyRowProps={({ row }) => ({
        sx: isRestaurant
          ? {
              minHeight: "auto",
              backgroundColor: "transparent",
              "&:hover td": {
                backgroundColor: "transparent",
              },
              "&:last-child td": {
                borderBottom: "none",
              },
            }
          : {
              minHeight: isMobile ? "48px" : "54px",
              backgroundColor: row.index % 2 === 0 ? FACX_DT.zebra : FACX_DT.surface,
              "&:hover td": {
                backgroundColor: FACX_DT.greenSoft,
              },
              "&:last-child td": {
                borderBottom: "none",
              },
            },
      })}
      muiTableBodyCellProps={({ cell }) => {
        if (isRestaurant) {
          return {
            sx: {
              width: "100%",
              maxWidth: "100%",
              padding: "0 !important",
              borderBottom: "none",
              overflow: "hidden",
              backgroundColor: "transparent",
              boxSizing: "border-box",
            },
          };
        }
        const centerColumns = ["mrt-row-actions", "fcd_precio", "fcd_cantidad", "fcd_descuento", "fcd_itbms", "fcd_total"];
        return {
          align: centerColumns.includes(cell.column.id) ? "center" : "left",
          sx: {
            padding: isMobile ? "8px 7px !important" : "11px 12px !important",
            borderBottom: `1px solid ${FACX_DT.line}`,
            color: FACX_DT.ink,
            fontSize: isMobile ? "12px !important" : "14px !important",
            fontWeight: 500,
            lineHeight: 1.35,
          },
        };
      }}
    />
  );
}

function DATATABLE_RESTAURANTE({ deleteRow, handleSaveRow, dataOrdenes, enableTab, usr_precio, isRestaurant, isEditing, isOpenMesasDiv }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "", // sin título en la columna de acciones (más limpio, como el demo)
          size: 84,
          muiTableHeadCellProps: { align: "center" },
        },
      }}
      state={{ columnVisibility: { art_descripcions: false } }}
      layoutMode="semantic"
      enableTableHead={false}
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={false}
      enableTopToolbar={false}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={false}
      enableSorting={false}
      enableFilters={false}
      enableStickyHeader={false}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{ placeholder: "Buscar" }}
      muiTablePaperProps={{
        elevation: 0,
        sx: {
          backgroundColor: "transparent",
          borderRadius: 0,
          boxShadow: "none",
          "& .MuiTableContainer-root": {
            borderRadius: 0,
          },
        },
      }}
      muiTableProps={{
        sx: {
          borderCollapse: "separate",
          borderSpacing: "0 6px", // separación entre filas tipo "tarjeta"
        },
      }}
      muiTableContainerProps={{
        sx: {
          maxHeight: isRestaurant ? (isOpenMesasDiv ? "32dvh" : "0vh") : "57dvh",
          backgroundColor: "transparent",
        },
      }}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta añadiendo productos en el panel izquierdo.</div>
        </div>
      )}
      columns={COLUMNS_ORDENES_DETALLE_RESTAURANTE(usr_precio)}
      onEditingRowSave={handleSaveRow}
      data={enableTab ? [] : dataOrdenes}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-surface)",
          color: "var(--rt-muted)",
          fontSize: "0.68rem",
          fontWeight: 700,
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          borderBottom: "1px solid var(--rt-border)",
          paddingTop: "6px",
          paddingBottom: "6px",
          "& .Mui-TableHeadCell-Content": { justifyContent: "inherit" },
        },
      }}
      renderRowActions={({ row, table }) => {
        const disabled = isEditing;
        return (
          <Box sx={{ display: "flex", gap: "2px", justifyContent: "center" }}>
            <IconButton
              size="small"
              disabled={row.original.ordd_entregado === "0" || row.original.ordd_entregado === undefined ? false : true}
              onClick={row.original.ordd_entregado === "0" || row.original.ordd_entregado === undefined ? () => table.setEditingRow(row) : undefined}
              sx={{
                color: "var(--rt-muted)",
                borderRadius: "8px",
                padding: "6px",
                "&:hover": {
                  backgroundColor: "var(--rt-primary-soft)",
                  color: "var(--rt-primary)",
                },
              }}
            >
              <PencilIcon />
            </IconButton>
            <IconButton
              size="small"
              disabled={row.original.ordd_entregado === "0" || row.original.ordd_entregado === undefined ? false : true}
              onClick={row.original.ordd_entregado === "0" || row.original.ordd_entregado === undefined ? () => deleteRow(row) : undefined}
              sx={{
                color: "var(--rt-muted)",
                borderRadius: "8px",
                padding: "6px",
                "&:hover": {
                  backgroundColor: "rgba(192,57,43,0.1)",
                  color: "var(--rt-danger, #c0392b)",
                },
              }}
            >
              <Trash2Icon />
            </IconButton>
          </Box>
        );
      }}
      muiTableBodyRowProps={({ row }) => {
        const enCocina = row.original.ordd_entregado === "0";
        return {
          sx: {
            backgroundColor: enCocina ? "var(--rt-accent-soft)" : "var(--rt-surface)",
            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
            "& td": {
              borderTop: "none",
              borderBottom: "none",
            },
            "& td:first-of-type": {
              borderTopLeftRadius: "10px",
              borderBottomLeftRadius: "10px",
            },
            "& td:last-of-type": {
              borderTopRightRadius: "10px",
              borderBottomRightRadius: "10px",
            },
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        const id = cell.column.id;
        const isTotal = id === "ordd_total";
        const isNumeric = id === "ordd_precio" || id === "ordd_cantidad" || id === "ordd_total";
        return {
          sx: {
            color: "var(--rt-text)",
            fontFamily: isNumeric ? "var(--rt-mono)" : "inherit",
            fontWeight: isTotal ? 700 : id === "mrt-row-actions" ? 700 : 400,
            fontSize: id === "mrt-row-actions" || id === "art_descripcion" ? "12px" : "14px",
            textAlign: id === "mrt-row-actions" || isNumeric ? "center" : "left",
            paddingTop: "8px",
            paddingBottom: "8px",
          },
        };
      }}
    />
  );
}
function DATATABLE_BODEGAS({ dataBodegas, setBasicModalDelete, setFormBodegas, setBasicModal, setBasicModalEdit, setError, fetchBodega, setBodegaPrincipal }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataBodegas.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataBodegas, pagination.pageSize, pagination.pageIndex]);

  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 150,
          minSize: 150,
          maxSize: 150,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "bod_nombre") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_BODEGA}
      data={dataBodegas}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-130px mx-auto">
            {row.original.bod_primary !== "1" && (
              <IconButton
                color="error"
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormBodegas(row.original);
                  setError("");
                }}
              >
                <Trash2Icon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormBodegas(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <PencilIcon />
            </IconButton>
            {row.original.bod_primary === "1" ? (
              <IconButton>
                <RadioButtonCheckedIcon />
              </IconButton>
            ) : (
              <IconButton
                onClick={() => {
                  setBodegaPrincipal(row.original);
                  setError("");
                }}
              >
                <RadioButtonUncheckedIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModal(true);
              setFormBodegas({
                bod_id: "",
                bod_nombre: "",
                bod_ubicacion: "",
                bod_sts: "",
              });
              setBasicModalEdit(false);
              setError("");
            }}
          >
            Agregar bodega
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchBodega()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_MARCAS({ dataMarcas, setBasicModalDelete, setFormMarcas, setBasicModal, setBasicModalEdit, setError, fetchMarcas, isLoadingM }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataMarcas.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataMarcas, pagination.pageSize, pagination.pageIndex]);

  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ isLoading: isLoadingM, pagination }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "mar_descripcion") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight >= 1000 ? "85dvh" : "74dvh" } }}
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_MARCAS}
      data={dataMarcas}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormMarcas(row.original);
                setError("");
              }}
            >
              <Trash2Icon />
            </IconButton>
            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormMarcas(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <PencilIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModal(true);
              setFormMarcas({
                mar_id: "",
                mar_descripcion: "",
                mar_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            Agregar marca
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchMarcas()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_CATEGORIAS({ dataCategorias, setBasicModalDelete, setFormCategorias, setBasicModal, setBasicModalEdit, setError, fetchCategoria, isLoadingCa }) {
  const { dataCompania } = useContext(StoreContext);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: window.innerHeight >= 1000 ? 30 : 10,
  });
  useEffect(() => {
    const totalPages = Math.ceil(dataCategorias.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataCategorias, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{
        isLoading: isLoadingCa,
        pagination,
        columnVisibility: {
          co_desc: dataCompania.com_restaurante === "1" ? true : false,
        },
      }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "cat_descripcion") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight >= 1000 ? "78dvh" : "70dvh" } }}
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_CATEGORIAS}
      data={dataCategorias}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormCategorias(row.original);
                setError("");
              }}
            >
              <Trash2Icon />
            </IconButton>
            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormCategorias(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <PencilIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModal(true);
              setFormCategorias({
                cat_id: "",
                cat_descripcion: "",
                cat_sts: "",
                co_id: "1",
                co_desc: "",
              });
              setBasicModalEdit(false);
              setError("");
            }}
          >
            Agregar Categoria
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchCategoria()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_PROVEEDORES({ dataProveedores, setBasicModalDelete, setFormProveedores, setBasicModal, setBasicModalEdit, setError, fetchProveedores, isLoadingP, handleExportData }) {
  const { dataCompania } = useContext(StoreContext);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: window.innerHeight >= 1000 ? 30 : 10,
  });
  useEffect(() => {
    const totalPages = Math.ceil(dataProveedores.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataProveedores, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{
        isLoading: isLoadingP,
        pagination,
        columnVisibility: {
          co_desc: dataCompania.com_restaurante === "1" ? true : false,
        },
      }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "prov_nombre") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_PROVEEDORES()}
      data={dataProveedores}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormProveedores(row.original);
                setError("");
              }}
            >
              <Trash2Icon />
            </IconButton>
            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormProveedores(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <PencilIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModal(true);
              setFormProveedores({
                prov_id: "",
                prov_suc: "",
                prov_nombre: "",
                prov_direccion: "",
                prov_telefono: "",
                prov_ruc: "",
                prov_dv: "",
                prov_sts: "",
                prov_email: "",
              });
              setBasicModalEdit(false);
              setError("");
            }}
          >
            Agregar
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchProveedores()}>
            <RefreshIcon />
          </IconButton>
          <IconButton
            onClick={handleExportData}
            title="Exportar CSV"
            sx={{
              borderRadius: "8px",
              padding: "6px 12px",
              gap: "6px",
              fontSize: "13px",
              fontWeight: 600,
              border: "1px solid #ddd",
            }}
          >
            <CsvDownloadIcon />
            CSV
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_MOVIMIENTO_INVENTARIO({
  dataMovimiento,
  setFormMovimientoDelete,
  setBasicModalDeleteMov,
  fetchMovimientoDetalle,
  setFormMov,
  setBasicModalMov,
  setBasicModalEditMov,
  setPrintM,
  setFormProcessMov,
  setBasicModalProcesarMov,
  setOBJMovimientoDetalle,
  fetchMovimiento,
  setFormMovimientoDetalle,
}) {
  const { dataCompania } = useContext(StoreContext);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: window.innerHeight >= 1000 ? 30 : 10,
  });
  useEffect(() => {
    const totalPages = Math.ceil(dataMovimiento.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataMovimiento, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{
        pagination,
        columnVisibility: {
          co_desc: dataCompania.com_restaurante === "1" ? true : false,
        },
      }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 160,
          minSize: 160,
          maxSize: 160,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        if (column.id === "mov_id") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={false}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight >= 1000 ? "85dvh" : "74dvh" } }}
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      columns={COLUMNS_MOV_MOVIMIENTO()}
      data={dataMovimiento}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-delete">
            {row.original.mov_procesado === "1" ? null : (
              <IconButton
                color="error"
                onClick={() => {
                  setFormMovimientoDelete({ mov_id: row.original.mov_id, mov_sts: 0 });
                  setBasicModalDeleteMov(true);
                }}
              >
                <Trash2Icon />
              </IconButton>
            )}

            {row.original.mov_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setBasicModalEditMov(true);
                  setBasicModalMov(true);
                  setFormMov({
                    mov_id: row.original.re_id,
                    mov_identificador: row.original.re_identificador,
                    mov_fecha: moment(row.original.re_fecha).format("YYYY-MM-DD"),
                    mov_fecha_procesado: row.original.re_fecha_procesado,
                    mov_procesado: row.original.mov_procesado,
                    mov_bodega_desde: row.original.mov_bodega_desde,
                    mov_bodega_hacia: row.original.mov_bodega_hacia,
                    mov_descripcion: row.original.re_descripcion,
                  });
                  fetchMovimientoDetalle({
                    mov_identificador: row.original.mov_identificador,
                  });
                }}
              >
                <PencilIcon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setPrintM(true);
                setFormMov({
                  mov_id: row.original.re_id,
                  mov_identificador: row.original.re_identificador,
                  mov_fecha: row.original.re_fecha,
                  mov_fecha_procesado: row.original.re_fecha_procesado,
                  mov_procesado: row.original.mov_procesado,
                  mov_bodega_desde: row.original.mov_bodega_desde,
                  mov_bodega_hacia: row.original.mov_bodega_hacia,
                  mov_descripcion: row.original.re_descripcion,
                });
                fetchMovimientoDetalle({ mov_identificador: row.original.mov_identificador });
              }}
            >
              <PrintIcon />
            </IconButton>
            {row.original.mov_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setFormProcessMov({
                    mov_identificador: row.original.mov_identificador,
                    mov_id: row.original.mov_id,
                  });
                  setBasicModalProcesarMov(true);
                }}
              >
                <ProcessDocumentIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModalEditMov(false);
              setBasicModalMov(true);
              setFormMovimientoDetalle(STATES_MOV_MOVIMIENTO({ staneName: "formMovimientoDetalle" }));
              setFormMov(STATES_MOV_MOVIMIENTO({ staneName: "formMovimiento" }));
              setOBJMovimientoDetalle([]);
            }}
          >
            Agregar movimiento
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchMovimiento()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_COLUMNS_RENCUENTO({ enableTab, dataRecuentoDetalle, handleSaveRow, deleteRow }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataRecuentoDetalle.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataRecuentoDetalle, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      state={{
        pagination,
        columnVisibility: {
          fcd_descuento_number: false,
          red_cantidad: window.innerWidth <= 611 ? false : true,
          art_upc: window.innerWidth <= 611 ? false : true,
          art_descripcion: window.innerWidth <= 611 ? false : true,
        },
      }}
      layoutMode="semantic"
      editDisplayMode="modal"
      enableBottomToolbar={true}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "art_upc") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 8,
          minSize: 80,
          maxSize: 80,
          grow: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      renderRowActions={({ row, table }) => (
        <Box>
          <IconButton onClick={() => table.setEditingRow(row)}>
            <PencilIcon />
          </IconButton>
          <IconButton onClick={() => deleteRow(row)}>
            <Trash2Icon />
          </IconButton>
        </Box>
      )}
      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <div className="mtc-edit-header">
            <div className="mtc-edit-icon">
              <IconButton fas icon="edit" />
            </div>
            <div>
              <div className="mtc-edit-title">Editar artículo</div>
              <div className="mtc-edit-subtitle">Modifica la información</div>
            </div>
          </div>
          <div className="mtc-edit-body">
            <Row>
              {internalEditComponents.map((component, index) => (
                <Col xs={12} key={index} className="mb-3">
                  {component}
                </Col>
              ))}
            </Row>
          </div>
          <div className="mtc-edit-footer">
            <MrtEditActionButtons row={row} table={table} />
          </div>
        </>
      )}
      muiEditRowDialogProps={{
        slotProps: {
          paper: {
            sx: {
              borderRadius: "14px",
              overflow: "hidden",
              width: "560px",
              maxWidth: "194vw",
            },
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={true}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      data={enableTab ? [] : dataRecuentoDetalle}
      onEditingRowSave={handleSaveRow}
      columns={COLUMNS_RE_RECUENTO_DETALLE()}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_ITEMS_BODEGA({ dataItems, selectItem, setTabItems, setFormMovimientoDetalle, props, usr_a_costo }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataItems.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataItems, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ pagination, columnVisibility: { art_costo: usr_a_costo === "1" ? true : false } }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "art_upc" || column.id === "art_referencia") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      enableGlobalFilter={true}
      muiTableBodyRowProps={({ row }) => ({
        sx: {
          backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
        },
        onClick: () => {
          setFormMovimientoDetalle({ ...props, inv_qty: row.original.inv_qty });
          selectItem({ art_upc: row.original.art_upc, inv_qty: row.original.inv_qty });
          setTabItems(false);
        },
      })}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              onClick={() => {
                setFormMovimientoDetalle({ ...props, inv_qty: row.original.inv_qty });
                selectItem({ art_upc: row.original.art_upc, inv_qty: row.original.inv_qty });
                setTabItems(false);
              }}
            >
              <PlusIcon />
            </IconButton>
          </Box>
        );
      }}
      columns={COLUMNS_LISTA_ITEMS_BODEGA()}
      data={dataItems}
    />
  );
}
function DATATABLE_COLUMNS_MOVIMIENTO({ enableTab, dataMovimientoDetalle, handleSaveRow, deleteRow }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataMovimientoDetalle.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataMovimientoDetalle, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "art_upc") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <div className="mtc-edit-header">
            <div className="mtc-edit-icon">
              <IconButton fas icon="edit" />
            </div>
            <div>
              <div className="mtc-edit-title">Editar artículo</div>
              <div className="mtc-edit-subtitle">Modifica la información</div>
            </div>
          </div>
          <div className="mtc-edit-body">
            <Row>
              {internalEditComponents.map((component, index) => (
                <Col xs={12} key={index} className="mb-3">
                  {component}
                </Col>
              ))}
            </Row>
          </div>
          <div className="mtc-edit-footer">
            <MrtEditActionButtons row={row} table={table} />
          </div>
        </>
      )}
      muiEditRowDialogProps={{
        slotProps: {
          paper: {
            sx: {
              borderRadius: "14px",
              overflow: "hidden",
              width: "560px",
              maxWidth: "94vw",
            },
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" ? "rgba(219, 237, 220, 0.78)" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={false}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={true}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      enableFilters={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={false}
      columns={COLUMNS_MOVD_MOVIMIENTO_DETALLE()}
      data={enableTab ? [] : dataMovimientoDetalle}
      onEditingRowSave={handleSaveRow}
      renderRowActions={({ row, table }) => (
        <Box>
          <IconButton onClick={() => table.setEditingRow(row)}>
            <PencilIcon />
          </IconButton>
          <IconButton onClick={() => deleteRow(row)}>
            <Trash2Icon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_ITEMS({ dataItems, selectItem, setTabItems, select_detail_articulo, usr_a_costo }) {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: window.innerHeight >= 1000 ? 30 : 10,
  });
  useEffect(() => {
    const totalPages = Math.ceil(dataItems.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataItems, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{ pagination }}
      autoResetPageIndex={false}
      state={{
        pagination,
        columnVisibility: {
          art_descripcion: window.innerWidth <= 611 ? false : true,
          art_costo: usr_a_costo === "1" ? true : false,
          mar_descripcion: window.innerWidth <= 611 ? false : true,
        },
      }}
      onPaginationChange={setPagination}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "art_upc") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <div className="mtc-edit-header">
            <div className="mtc-edit-icon">
              <IconButton fas icon="edit" />
            </div>
            <div>
              <div className="mtc-edit-title">Editar artículo</div>
              <div className="mtc-edit-subtitle">Modifica la información</div>
            </div>
          </div>
          <div className="mtc-edit-body">
            <Row>
              {internalEditComponents.map((component, index) => (
                <Col xs={12} key={index} className="mb-3">
                  {component}
                </Col>
              ))}
            </Row>
          </div>
          <div className="mtc-edit-footer">
            <MrtEditActionButtons row={row} table={table} />
          </div>
        </>
      )}
      muiEditRowDialogProps={{
        slotProps: {
          paper: {
            sx: {
              borderRadius: "14px",
              overflow: "hidden",
              width: "560px",
              maxWidth: "94vw",
            },
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" ? "rgba(219, 237, 220, 0.78)" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                selectItem(row.original.art_upc);
                setTabItems(false);
              }}
            >
              <PlusIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                select_detail_articulo({ row: row.original });
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
        );
      }}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableGlobalFilter={true}
      muiTableBodyRowformFactura={({ row }) => {
        return {
          sx: {
            backgroundColor: row.original.re_fecha_procesado !== "0000-00-00 00:00:00" ? "rgba(219, 237, 220, 0.78)" : "",
            fontWeight: "bold",
          },
        };
      }}
      columns={COLUMNS_LISTA_ITEMS()}
      data={dataItems}
      muiTableContainerformFactura={{
        sx: {
          maxHeight: "290px",
        },
      }}
    />
  );
}
function DATATABLE_DC_COMPRA_DETALLE({ dataCompraDetalle, deleteRow, onBlurs, enableTab, handleSaveRow }) {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: window.innerHeight >= 1000 ? 30 : 10,
  });

  useEffect(() => {
    const totalPages = Math.ceil(dataCompraDetalle.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataCompraDetalle, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{ pagination }}
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      enableRowActions={true}
      positionActionsColumn="last"
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "var(--rt-primary-soft, #e2f1eb)",
          color: "var(--rt-primary-dark, #0f5f47)",
          fontWeight: 700,
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          borderBottom: "2px solid var(--rt-primary, #14795a)",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            fontWeight: 700,
          },
        },
      }}
      muiTableBodyCellProps={({ column }) => {
        // Primera columna (nombre) en negrita
        if (column.id === "art_upc") {
          return { sx: { fontWeight: 700, color: "var(--rt-text, #1e293b)" } };
        }
        return {};
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 110,
          minSize: 110,
          maxSize: 110,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <div className="mtc-edit-header">
            <div className="mtc-edit-icon">
              <IconButton fas icon="edit" />
            </div>
            <div>
              <div className="mtc-edit-title">Editar artículo</div>
              <div className="mtc-edit-subtitle">Modifica la información</div>
            </div>
          </div>
          <div className="mtc-edit-body">
            <Row>
              {internalEditComponents.map((component, index) => (
                <Col xs={12} key={index} className="mb-3">
                  {component}
                </Col>
              ))}
            </Row>
          </div>
          <div className="mtc-edit-footer">
            <MrtEditActionButtons row={row} table={table} />
          </div>
        </>
      )}
      muiEditRowDialogProps={{
        slotProps: {
          paper: {
            sx: {
              borderRadius: "14px",
              overflow: "hidden",
              width: "560px",
              maxWidth: "94vw",
            },
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" ? "rgba(219, 237, 220, 0.78)" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyProps={{
        sx: () => ({
          "& tr:nth-of-type(odd)": {},
        }),
      }}
      columns={COLUMNS_DC_COMPRA_DETALLE(deleteRow, onBlurs)}
      onEditingRowSave={handleSaveRow}
      data={enableTab ? [] : dataCompraDetalle}
      renderRowActions={({ row, table }) => (
        <Box>
          <IconButton onClick={() => table.setEditingRow(row)}>
            <PencilIcon />
          </IconButton>
          <IconButton onClick={() => deleteRow(row)}>
            <Trash2Icon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_EXSITENCIA_INVENTARIO({ dataExistenciaInv }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: window.innerHeight >= 1000 ? 35 : 20, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight >= 1000 ? "70dvh" : "65dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_EXISTENCIA_INVENTARIO()}
      data={dataExistenciaInv}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
    />
  );
}
function DATATABLE_CLIENTES_HISTORIAL({ dataHistorialClientes }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 10, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "60dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_CLIENTES_HISTORIAL}
      data={dataHistorialClientes}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign: cell.column.id === "mrt-row-actions" || cell.column.id === "cli_telefono" || cell.column.id === "cli_ruc" || cell.column.id === "cli_limitc" ? "center" : "center",
          },
        };
      }}
    />
  );
}
function DATATABLE_CLIENTES_REPORTE({ dataClientes, setFormClientes, find_historial, dataRetencion, setHistorialClientes }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 10, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "60dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_CLIENTES({ dataRetencion })}
      data={dataClientes}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign: cell.column.id === "mrt-row-actions" || cell.column.id === "cli_telefono" || cell.column.id === "cli_ruc" || cell.column.id === "cli_limitc" ? "center" : "center",
          },
        };
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      renderRowActions={({ row }) => {
        if (row.original.cli_id !== "16") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                // color="error"
                onClick={() => {
                  // setBasicModalDelete(true);
                  setFormClientes(row.original);
                  find_historial(row.original.cli_id);
                  setHistorialClientes(true);
                }}
              >
                <SearchIcon />
              </IconButton>
            </Box>
          );
        }
      }}
    />
  );
}
function DATATABLE_DESCUENTO({ dataDescuento, setBasicModalDelete, setFormDescuento, setBasicModal, setBasicModalEdit, setError, fetchDescuento, isLoadingG, setLoadingDes }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 30, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoadingG }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "74dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_DESCUENTO}
      data={dataDescuento}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        if (row.original.gr_id !== "1") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                color="error"
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormDescuento(row.original);
                  setError("");
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setFormDescuento(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <EditIcon />
              </IconButton>
            </Box>
          );
        } else {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setFormDescuento(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <EditIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setLoadingDes(false);
              setBasicModal(true);
              setFormDescuento({
                gr_id: "",
                gr_name: "",
                gr_descripcion: "",
                gr_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchDescuento()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_GASTOS({ dataGastos, setBasicModalDelete, setFormGastos, setBasicModal, setBasicModalEdit, setError, fetchGastos, isLoadingG, setImages, setValueSelected, handleExportData, descargar_zip }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: window.innerHeight >= 1000 ? 30 : 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoadingG }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight >= 1000 ? "85dvh" : "74dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_GAS_GASTOS}
      data={dataGastos}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormGastos(row.original);
                setError("");
              }}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                setBasicModal(true);
                setImages([]);
                setFormGastos(row.original);
                setBasicModalEdit(true);
                setValueSelected(row.original.tgs_desc);
                setError("");
              }}
            >
              <EditIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setImages([]);
              setBasicModal(true);
              setFormGastos({
                gs_id: "",
                gs_suc: "",
                gs_desc: "",
                gs_tipo: "",
                gs_imgType: "",
                gs_fecha: moment(new Date()).format("YYYY-MM-DD"),
                gs_file: "",
                tgs_desc: "",
                gs_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton>
            <Button
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={handleExportData}
              startIcon={<FileDownloadIcon />}
            >
              CSV
            </Button>
          </IconButton>
          <IconButton>
            <Button
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={descargar_zip}
              startIcon={<FileDownloadIcon />}
            >
              ZIP
            </Button>
          </IconButton>
          <IconButton onClick={() => fetchGastos({ date: moment(new Date()).format("YYYY-MM-DD") })}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_SERIES({ dataSeries }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: window.innerHeight >= 1000 ? 30 : 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight >= 1000 ? "75dvh" : "65dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_SERIES}
      data={dataSeries}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
    />
  );
}
function DATATABLE_APARTADO({ dataapartado, onClickUpdateapartado_sts, setFormapartado, setBasicModal, setBasicModalEdit, setOBJapartadoDetalle, fetchDCapartadoDetalle, setFormapartadoDetalle, fetchDCapartado, setPrintI }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 50, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "74dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_AP_APARTADO}
      data={dataapartado}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-delete mx-auto">
            <IconButton color="error" onClick={() => onClickUpdateapartado_sts({ ap_id: row.original.ap_id, ap_status: 0 })}>
              <DeleteIcon />
            </IconButton>
            {row.original.ap_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setBasicModalEdit(true);
                  setBasicModal(true);
                  setFormapartado({
                    ap_id: row.original.ap_id,
                    ap_docn: row.original.ap_docn,
                    ap_identificador: row.original.ap_identificador,
                    ap_proveedor: row.original.ap_proveedor,
                    prov_proveedor: row.original.prov_proveedor,
                    ap_procesado: row.original.ap_procesado,
                    apd_total: row.apd_total,
                    ap_fecha_procesado: row.original.ap_fecha_procesado,
                    ap_fecha: row.original.ap_fecha,
                    ap_descripcion: row.original.ap_descripcion,
                    ap_status: row.original.ap_status,
                  });
                  fetchDCapartadoDetalle(row.original.ap_identificador);
                  setBasicModalEdit(true);
                }}
              >
                <EditIcon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setPrintI(true);
                setFormapartado({
                  ap_id: row.original.ap_id,
                  ap_docn: row.original.ap_docn,
                  ap_identificador: row.original.ap_identificador,
                  ap_proveedor: row.original.ap_proveedor,
                  prov_proveedor: row.original.prov_proveedor,
                  ap_procesado: row.original.ap_procesado,
                  apd_total: row.apd_total,
                  ap_fecha_procesado: row.original.ap_fecha_procesado,
                  ap_fecha: row.original.ap_fecha,
                  ap_descripcion: row.original.ap_descripcion,
                  ap_status: row.original.ap_status,
                });
                fetchDCapartadoDetalle(row.original.ap_identificador);
              }}
            >
              <LocalPrintshopIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModalEdit(false);
              setBasicModal(true);
              setFormapartado({
                ap_id: "",
                ap_docn: "",
                ap_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
                ap_suc: "",
                ap_proveedor: "",
                ap_procesado: "",
                apd_total: "",
                prov_proveedor: "",
                ap_fecha_procesado: "",
                ap_fecha: moment(new Date()).format("YYYY-MM-DD"),
                ap_descripcion: "",
                ap_status: "",
              });
              setFormapartadoDetalle({
                apd_id: "",
                apd_articulo: "",
                apd_precio: "",
                apd_cantidad: "1",
                apd_itbms: "",
                apd_descuento: "",
                apd_total: "",
                apd_descuento_number: "",
                art_descripcion: "",
                art_upc: "",
              });
              setOBJapartadoDetalle([]);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchDCapartado()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_ARTICULO({
  usr_perfil,
  dataArticulos,
  setBasicModalDelete,
  setBasicModalEdit,
  setBasicModal,
  setFormArticulos,
  setImages,
  fetchArticulos,
  setFormDropDown,
  setError,
  setDataArticuloBodega,
  setSrcImage,
  setModalImageTooltip,
  setImgName,
  setPrintTooltip,
  handleExportData,
  usr_a_costo,
  openModalSeries,
}) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataArticulos.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataArticulos, pagination.pageSize, pagination.pageIndex]);
  const { dataCompania } = useContext(StoreContext);
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      // state={{pagination }}
      onPaginationChange={setPagination}
      paginationDisplayMode="default"
      muiTableContainerProps={{
        sx: {
          maxHeight: window.innerWidth <= 611 ? (window.innerWidth <= 430 ? (window.innerWidth <= 370 ? "70dvh" : "75dvh") : "79dvh") : "69dvh",
        },
      }} //370w 420w, 611w, desktop
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370 ? 55 : 55,
          maxSize: window.innerWidth <= 370 ? 55 : 55,
          minSize: window.innerWidth <= 370 ? 55 : 55,

          muiTableBodyCellProps: {
            sx: {
              // display: "flex",
              justifyContent: "center",
              width: "55px",
              alignItems: "center",
              "& button": {
                marginX: window.innerWidth <= 430 ? "3px" : "6px",
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      state={{
        pagination,
        columnVisibility: {
          art_restaurante: dataCompania.com_restaurante === "1" ? true : false,
          co_desc: dataCompania.com_restaurante === "1" ? true : false,
          art_costo: usr_a_costo === "1" ? true : false,
        },
      }}
      globalFilterFn="contains"
      layoutMode="semantic"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      enableGlobalFilter={true}
      positionActionsColumn={window.innerWidth <= 611 ? "last" : "first"}
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_ARTICULOS(openModalSeries)}
      data={dataArticulos}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign: cell.column.id === "art_restaurante" && "center",
          },
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyProps={{
        sx: () => ({
          "& tr:nth-of-type(odd)": {},
        }),
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="d-flex">
            {usr_perfil === "1" && (
              <>
                {" "}
                <IconButton
                  color="error"
                  onClick={() => {
                    setBasicModalDelete(true);
                    setFormArticulos(row.original);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </>
            )}

            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormArticulos(row.original);
                setImages([]);
                setBasicModalEdit(true);
                setFormDropDown({
                  mar_id: row.original.art_marca,
                  mar_descripcion: row.original.mar_descripcion,
                  cat_id: row.original.art_categoria,
                  cat_descripcion: row.original.cat_descripcion,
                  prov_id: row.original.art_proveedor,
                  prov_nombre: row.original.prov_nombre,
                  itbm_cod_venta: row.original.art_itbm_cod_v,
                  itbm_porc_v: row.original.art_itbm_venta,
                  itbm_cod_compra: row.original.art_itbm_cod_c,
                  itbm_porc_c: row.original.art_itbm_compra,
                  bod_id: row.original.bod_id,
                  bod_nombre: row.original.bod_nombre,
                });
                setError("");
              }}
            >
              <EditIcon />
            </IconButton>
            {window.innerWidth <= 611 ? null : (
              <img
                src={BARCODE_IMAGE}
                alt=""
                className="img-barcode"
                onClick={() => {
                  setPrintTooltip(true);
                  setFormArticulos(row.original);
                }}
              />
            )}

            {row.original.art_img === "1" ? (
              <img
                className="img-art-datatable"
                alt=""
                onClick={() => {
                  setFormArticulos(row.original);
                  setImgName(row.original.art_upc);
                  setSrcImage(imgURLocalImage + row.original.art_imgName);
                  setModalImageTooltip(true);
                }}
                src={imgURLocalImage + row.original.art_imgName}
              />
            ) : null}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModal(true);
              setDataArticuloBodega([]);
              setPrintTooltip(false);
              setImages([]);
              setBasicModalEdit(false);
              setFormDropDown({
                mar_id: "",
                mar_descripcion: "",
                cat_id: "",
                cat_descripcion: "",
                prov_id: "",
                prov_nombre: "",
                bod_id: "",
                bod_nombre: "",
                itbm_cod_venta: "",
                itbm_porc_v: "",
                itbm_descripcion_venta: "",
                itbm_cod_compra: "",
                itbm_porc_c: "",
                itbm_descripcion_compra: "",
              });
              setFormArticulos({
                art_id: "",
                art_upc: "",
                art_sucursal: "",
                art_categoria: "",
                art_proveedor: "",
                art_marca: "",
                art_descripcion: "",
                art_costo: "",
                art_precio: "",
                art_precio2: "",
                art_precio3: "",
                art_referencia: "",
                art_linea_roja: "0",
                art_img: "",
                art_imgdataurl: "",
                art_imgType: "",
                art_imgName: "",
                art_serie: "",
                art_itbm_venta: "",
                art_itbm_compra: "",
                art_sts: "",
                inv_id: "",
                inv_qty: "",
                art_restaurante: "0",
                art_comanda: "1",
                co_desc: "",
              });
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchArticulos()}>
            <CachedIcon />
          </IconButton>
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            CSV
          </Button>
        </Box>
      )}
    />
  );
}
function DATATABLE_LISTA_ITEMS2({ dataItems }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 50, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "65dvh" } }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign: cell.column.id === "mrt-row-actions" || cell.column.id === "re_fecha" || cell.column.id === "re_fecha_procesado" ? "center" : "left",
          },
        };
      }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.original.re_fecha_procesado !== "0000-00-00 00:00:00" ? "rgba(219, 237, 220, 0.78)" : "",
            fontWeight: "bold",
            height: "60px",
          },
        };
      }}
      columns={COLUMNS_LISTA_ITEMS}
      data={dataItems}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_ANULACION({ dataListAnulacion, setTabAnular, setTabAnularNC, setFormAnulacion, getDetailItem }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 50, pageIndex: 0 },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={true}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? "70dvh" : "55dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      enableGlobalFilter={true}
      muiTableBodyProps={{
        sx: () => ({
          "& tr:nth-of-type(odd)": {},
        }),
      }}
      renderRowActions={({ row, table }) => {
        return (
          <Box className="width-box-delete-opciones mx-auto d-flex">
            <IconButton
              onClick={() => {
                setTabAnular(false);
                setFormAnulacion({ ...row.original, motivo_anulacion: "" });
              }}
              color="error"
            >
              <DeleteIcon />
            </IconButton>
            {row.original.fac_recibo === "1" && row.original.fac_tipodocumento === "01" && (
              <IconButton
                onClick={() => {
                  setTabAnularNC(true);
                  setTabAnular(false);
                  getDetailItem({ data: row.original });
                  setFormAnulacion({ ...row.original, motivo_anulacion: "" });
                }}
              >
                <ReceiptLongIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370 ? 80 : 70,
          maxSize: window.innerWidth <= 370 ? 80 : 70,
          minSize: window.innerWidth <= 370 ? 80 : 70,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              // width:"70px",
              alignItems: "center",
              "& button": {
                marginX: window.innerWidth <= 430 ? "5px" : "1px",
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          // onClick: () => {
          //   setTabAnular(false);
          //   setFormAnulacion({ ...row.original, motivo_anulacion: "" });
          // },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      columns={COLUMNS_LISTA_ANULACION(setTabAnular, setFormAnulacion)}
      data={dataListAnulacion}
      muiTableContainerformFactura={{
        sx: {
          maxHeight: "290px",
        },
      }}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_FPAGO({ dataListpago, handleSaveRow, deleteRow }) {
  const isMobile = useMediaQuery("(max-width:611px)");

  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      columns={COLUMNS_LISTA_FPAGO(isMobile)}
      data={Array.isArray(dataListpago) ? dataListpago : []}
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={false}
      enableTopToolbar={false}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={false}
      enableSorting={false}
      enableFilters={false}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      state={{
        columnVisibility: {
          list_monto: !isMobile,
        },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: isMobile ? 82 : 110,
          minSize: isMobile ? 82 : 110,
          maxSize: isMobile ? 82 : 110,

          muiTableHeadCellProps: {
            align: "center",
          },

          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiTablePaperProps={{
        elevation: 0,
        className: "pago-fpago-paper",
        sx: {
          border: "1px solid #e0e4eb",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "none",
        },
      }}
      muiTableContainerProps={{
        className: "pago-fpago-container",
        sx: {
          maxHeight: isMobile ? "32.5dvh" : "40dvh",
          overflowY: "auto",
          overflowX: "hidden",
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          minHeight: "44px !important",
          padding: "9px 12px !important",

          backgroundColor: "#f5f7fa !important",
          color: "#56647a !important",

          borderBottom: "1px solid #dce3ec !important",

          fontSize: "11px !important",
          fontWeight: "800 !important",
          letterSpacing: "0.04em",
          textTransform: "uppercase",

          "& .Mui-TableHeadCell-Content": {
            justifyContent: "center",
          },

          "& .Mui-TableHeadCell-Content-Labels": {
            color: "#56647a !important",
            fontWeight: "800 !important",
          },

          "& svg": {
            color: "#738095 !important",
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => ({
        sx: {
          backgroundColor: row.index % 2 === 0 ? "#ffffff" : "#f8fafc",

          "&:hover td": {
            backgroundColor: "#f1eff5 !important",
          },

          "&:last-child td": {
            borderBottom: "none",
          },
        },
      })}
      muiTableBodyCellProps={({ cell }) => ({
        align: "center",

        sx: {
          padding: "11px 12px !important",

          color: "#172033",

          borderBottom: "1px solid #e6ebf1 !important",

          fontSize: "13px !important",
          fontWeight: 600,
        },
      })}
      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <DialogTitle
            sx={{
              color: "#36304a",
              fontSize: "18px",
              fontWeight: 800,
            }}
          >
            Editar pago
          </DialogTitle>

          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",

              "& .MuiInputBase-input": {
                fontSize: "14px",
              },
            }}
          >
            {internalEditComponents}
          </DialogContent>

          <DialogActions>
            <MrtEditActionButtons variant="icon" table={table} row={row} />
          </DialogActions>
        </>
      )}
      onEditingRowSave={handleSaveRow}
      renderEmptyRowsFallback={() => (
        <div className="pago-fpago-empty">
          <MDBIcon fas icon="credit-card" />
          <span>No hay pagos agregados</span>
        </div>
      )}
      renderRowActions={({ row, table }) => (
        <Box className="pago-fpago-actions">
          <IconButton className="pago-fpago-edit" title="Editar" onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>

          <IconButton className="pago-fpago-delete" title="Eliminar" onClick={() => deleteRow(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_ORDENES({ selectItemOrdenes, dataListOrdenes, deleteRow }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      state={{
        selectItemOrdenes,
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      // muiTableBodyRowProps={({ row }) => {
      //   return {
      //     onClick: () => {
      //       selectItemOrdenes({ ordd_identificador: row.original.ord_identificador,ord_mesa:row.original.ord_mesa,res_nombre:row.original.res_nombre });
      //     },
      //     sx: {
      //       backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
      //       fontWeight: "bold",
      //     },
      //   };
      // }}

      renderRowActions={({ row, table }) => {
        return (
          <Box className="width-box-delete-opciones mx-auto d-flex">
            <IconButton
              onClick={() => {
                selectItemOrdenes({
                  ordd_identificador: row.original.ord_identificador,
                  ord_mesa: row.original.ord_mesa,
                  res_nombre: row.original.res_nombre,
                });
              }}
            >
              <AddBoxIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                deleteRow({ row: row.original });
              }}
              color="error"
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        );
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_ORDENES()}
      data={dataListOrdenes}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_CREDITOS_PAGO({ dataListCreditoPago, deleteRow }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      renderRowActions={({ row, table }) => (
        <Box className="text-center">
          <IconButton onClick={() => deleteRow(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      initialState={{
        pagination: { pageSize: 30, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={false}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFilters={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={false}
      columns={COLUMNS_LISTA_CREDITOS_PAGO()}
      data={dataListCreditoPago}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_CREDITOS_DETALLE({ selectCreditosPago, dataListCreditoDetalle, setCreditoPago, setCreditoDetalle, setFacIdentificador, setFormPagoCredito, formPagoCredito, printFac }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          onClick: () => {
            selectCreditosPago({ crd_fac_identificador: row.original.fac_identificador });
            setFacIdentificador(row.original.fac_identificador);
            setCreditoPago(true);
            setCreditoDetalle(false);
            setFormPagoCredito({
              ...formPagoCredito,
              fac_id: row.original.fac_id.toString().padStart(10, "0"),
              fac_identificador: row.original.fac_identificador,
              crd_fecha: row.original.crd_fecha,
              crd_monto: row.original.crd_monto_c,
              crp_monto: row.original.crp_monto_p,
            });
          },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={true}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_CREDITOS_DETALLE(printFac)}
      data={dataListCreditoDetalle}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_CREDITOS({ selectCreditosDetalle, dataListCreditos, setCreditoDetalle, setCrpCliente, setCliName, setMontoAdeudado, setFormPagoCredito, formPagoCredito }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      initialState={{
        pagination: { pageSize: 20, pageIndex: 0 },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          onClick: () => {
            selectCreditosDetalle({ crd_cliente: row.original.cli_id });
            setCrpCliente(row.original.cli_id);
            setCreditoDetalle(true);
            setCliName(row.original.cli_nombre);
            setMontoAdeudado(row.original.crd_monto_c);
            setFormPagoCredito({
              ...formPagoCredito,
              cli_name: row.original.cli_nombre,
              cli_telefono: row.original.cli_telefono,
              cli_ruc: row.original.cli_dv !== "" ? row.original.cli_ruc + " " + row.original.cli_dv : row.original.cli_ruc,
            });
          },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? "68dvh" : "57dvh" } }}
      enableStickyHeader={false}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_CREDITOS()}
      data={dataListCreditos}
    />
  );
}
function DATATABLE_CREDITOS({ dataCreditos, handleExportData }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            CSV
          </Button>
        </Box>
      )}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" ? "rgba(219, 237, 220, 0.78)" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_CREDITOS()}
      data={dataCreditos}
    />
  );
}
function DATATABLE_CREDITOS_PAGO({ handleExportData, dataCreditospago }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            CSV
          </Button>
        </Box>
      )}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" ? "rgba(219, 237, 220, 0.78)" : "",
            fontWeight: "bold",
          },
        };
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_CREDITOS_PAGO()}
      data={dataCreditospago}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_COTIZACION({ selectItemCotizacion, dataListCotizacion }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      state={{
        selectItemCotizacion,
      }}
      initialState={{
        pagination: { pageSize: 30, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight: cell.column.id === "cot_id" ? "bold" : "",
          },
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          onClick: () => {
            selectItemCotizacion({ cot_identificador: row.original.cot_identificador });
          },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{
        sx: {
          maxHeight: window.innerWidth <= 611 ? (window.innerWidth <= 430 ? (window.innerWidth <= 370 ? "66dvh" : "70dvh") : "73dvh") : "57dvh",
        },
      }} //370w 420w, 611w, desktop
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableColumnFilters={false}
      enableHiding={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_COTIZACION()}
      data={dataListCotizacion}
    />
  );
}
function DATATABLE_ENTRADA_FACTURA_COMPRA({ dataEntradaFCompra }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{
        sx: { maxHeight: window.innerWidth <= 611 ? (window.innerWidth <= 430 ? "71dvh" : "73dvh") : "85dvh" },
      }} //420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight >= 1000 ? 30 : 15, pageIndex: 0 },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={false}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      columns={COLUMNS_ENTRADA_FACTURA_COMPRA}
      data={dataEntradaFCompra}
    />
  );
}
function DATATABLE_ENTRADA_INVENTARIO({ dataEntradaInventario }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{
        sx: { maxHeight: window.innerWidth <= 611 ? (window.innerWidth <= 430 ? "71dvh" : "73dvh") : "85dvh" },
      }} //420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight >= 1000 ? 30 : 15, pageIndex: 0 },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={false}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      columns={COLUMNS_ENTRADA_INVENTARIO}
      data={dataEntradaInventario}
    />
  );
}
function DATATABLE_SALIDA_VENTA({ dataSalidaVenta }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{
        sx: { maxHeight: window.innerWidth <= 611 ? (window.innerWidth <= 430 ? "71dvh" : "73dvh") : "85dvh" },
      }} //420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight >= 1000 ? 30 : 15, pageIndex: 0 },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={false}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      columns={COLUMNS_SALIDA_VENTA}
      data={dataSalidaVenta}
    />
  );
}
function DATATABLE_INV_INVENTARIO({
  dataRecuento,
  setFormRecuentoDelete,
  setBasicModalDeleteRe,
  fetchRecuentoDetalle,
  setFormRecuento,
  setBasicModalRe,
  setBasicModalEditRe,
  setPrintI,
  setFormProcessRe,
  setBasicModalProcesarRe,
  setOBJRecuentoDetalle,
  fetchRecuento,
  setFormRecuentoDetalle,
  setFormDropDownInv,
}) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(dataRecuento.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [dataRecuento, pagination.pageSize, pagination.pageIndex]);
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      autoResetPageIndex={false}
      state={{ pagination }}
      onPaginationChange={setPagination}
      muiTableContainerProps={{
        sx: {
          maxHeight: window.innerWidth <= 611 ? (window.innerWidth <= 430 ? (window.innerWidth <= 370 ? "38dvh" : "71dvh") : "73dvh") : "85dvh",
        },
      }} //370w 420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight >= 1000 ? 30 : 15, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 160,
          minSize: 160,
          maxSize: 160,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight: cell.column.id === "art_upc" ? "bold" : "",
            textAlign: cell.column.id === "mrt-row-actions" || cell.column.id === "re_fecha" || cell.column.id === "re_fecha_procesado" ? "center" : "left",
          },
        };
      }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      columns={COLUMNS_RE_CUENTO}
      data={dataRecuento}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-delete">
            {row.original.re_procesado === "0" ? (
              <IconButton
                color="error"
                onClick={() => {
                  setFormRecuentoDelete({ re_id: row.original.re_id, re_status: 0 });
                  setBasicModalDeleteRe(true);
                }}
              >
                <Trash2Icon />
              </IconButton>
            ) : null}

            {row.original.re_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setBasicModalEditRe(true);
                  setBasicModalRe(true);
                  setFormRecuento({
                    re_id: row.original.re_id,
                    re_identificador: row.original.re_identificador,
                    re_fecha: moment(row.original.re_fecha).format("YYYY-MM-DD"),
                    re_fecha_procesado: row.original.re_fecha_procesado,
                    re_procesado: row.original.re_procesado,
                    usr_nombre: row.original.usr_nombre,
                    bod_nombre: row.original.bod_nombre,
                    re_descripcion: row.original.re_descripcion,
                  });
                  setFormDropDownInv({ bod_id: row.original.bod_id, bod_nombre: row.original.bod_nombre });
                  fetchRecuentoDetalle({
                    re_identificador: row.original.re_identificador,
                  });
                }}
              >
                <PencilIcon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setPrintI(true);
                setFormRecuento({
                  re_id: row.original.re_id,
                  re_identificador: row.original.re_identificador,
                  re_fecha: row.original.re_fecha,
                  re_fecha_procesado: row.original.re_fecha_procesado,
                  re_procesado: row.original.re_procesado,
                  usr_nombre: row.original.usr_nombre,
                  bod_nombre: row.original.bod_nombre,
                  re_descripcion: row.original.re_descripcion,
                });
                fetchRecuentoDetalle({ re_identificador: row.original.re_identificador });
              }}
            >
              <PrintIcon />
            </IconButton>
            {row.original.re_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setFormProcessRe({
                    red_identificador: row.original.re_identificador,
                    re_id: row.original.re_id,
                    re_sucursal: row.original.re_sucursal,
                    bod_id: row.original.bod_id,
                    bod_nombre: row.original.bod_nombre,
                  });
                  setBasicModalProcesarRe(true);
                }}
              >
                <ProcessDocumentIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px" }}>
          <Button
            variant="contained"
            disableElevation
            startIcon={<PlusIcon />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 16px",
              backgroundColor: "var(--rt-primary, #14795a)",
              "&:hover": { backgroundColor: "var(--rt-primary-dark, #0f5f47)" },
            }}
            onClick={() => {
              setBasicModalEditRe(false);
              setBasicModalRe(true);
              setFormRecuentoDetalle(STATES_RE_RECUENTO({ staneName: "formRecuentoDetalle" }));
              setFormRecuento(STATES_RE_RECUENTO({ staneName: "formRecuento" }));
              setOBJRecuentoDetalle([]);
              setFormDropDownInv({ bod_id: "", bod_nombre: "" });
            }}
          >
            Agregar inventario
          </Button>
          <IconButton sx={toolbarBtnSx} title="Refrescar" onClick={() => fetchRecuento()}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_ORDENES_NORMAL({ selectItemOrdenes, checkOrden, orders, deleteRow, togle }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: window.innerHeight >= 1000 ? 30 : 10 });
  useEffect(() => {
    const totalPages = Math.ceil(orders.length / pagination.pageSize);

    if (totalPages > 0 && pagination.pageIndex >= totalPages) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: totalPages - 1,
      }));
    }
  }, [orders, pagination.pageSize, pagination.pageIndex]);
  const { dataCompania } = useContext(StoreContext);
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      layoutMode="semantic"
      state={{
        selectItemOrdenes,
        pagination,
        columnVisibility: {
          ordd_cantidad: dataCompania.com_lavanderia === "1" ? true : false,
          ord_fecha_procesado: dataCompania.com_lavanderia === "1" ? true : false,
        },
      }}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderEmptyRowsFallback={() => (
        <div className="empty-records">
          <div className="empty-records-icon">
            <EmptyRecordsIcon />
          </div>
          <div className="empty-records-title">No hay registros que mostrar</div>
          <div className="empty-records-subtitle">Intenta cambiar los filtros o realizar una nueva búsqueda.</div>
        </div>
      )}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 70,
          minSize: 70,
          maxSize: 70,
          grow: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight: cell.column.id === "ord_identificador" ? "bold" : "",
          },
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      renderRowActions={({ row, table }) => {
        return (
          <Box className="d-flex">
            <IconButton
              onClick={() => {
                selectItemOrdenes({ ordd_identificador: row.original.ord_identificador });
              }}
            >
              <PlusIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                checkOrden({ row: row.original });
              }}
              color="primary"
            >
              {row.original.ord_flag === "1" ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
            </IconButton>
            {row.original.ordd_facturado === "1" && row.original.ord_flag === "1" ? (
              <IconButton
                onClick={() => {
                  put_facturado_orden({ ordd_identificador: row.original.ord_identificador });
                  togle();
                }}
                color="info"
              >
                <CheckBoxIcon />
              </IconButton>
            ) : null}
            <IconButton
              onClick={() => {
                deleteRow({ row: row.original });
              }}
              color="error"
            >
              <Trash2Icon />
            </IconButton>
          </Box>
        );
      }}
      globalFilterFn="contains"
      positionGlobalFilter="left"
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableFilters={true}
      enableColumnFilters={false}
      enableHiding={false}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={true}
      enableDensityToggle={false}
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_ORDENES_NORMAL()}
      data={orders}
    />
  );
}

export {
  DATATABLE_CPBS,
  DATATABLE_GARANTIA,
  DATATABLE_PUBLICIDAD,
  DATATABLE_MESAS,
  DATATABLE_AREAS,
  DATATABLE_ENTRADA_FACTURA_COMPRA,
  DATATABLE_ENTRADA_INVENTARIO,
  DATATABLE_SALIDA_VENTA,
  DATATABLE_MOVIMIENTO_INVENTARIO,
  DATATABLE_COLUMNS_MOVIMIENTO,
  DATATABLE_COLUMNS_LISTA_ORDENES_NORMAL,
  DATATABLE_DESCUENTO,
  DATATABLE_COLUMNS_LISTA_ORDENES,
  DATATABLE_RESTAURANTE,
  DATATABLE_CREDITOS_PAGO,
  DATATABLE_CREDITOS,
  DATATABLE_COLUMNS_LISTA_CREDITOS_PAGO,
  DATATABLE_COLUMNS_LISTA_CREDITOS_DETALLE,
  DATATABLE_COLUMNS_RENCUENTO,
  DATATABLE_COLUMNS_LISTA_COTIZACION,
  DATATABLE_COLUMNS_LISTA_FPAGO,
  DATATABLE_COLUMNS_LISTA_ANULACION,
  DATATABLE_DC_COMPRA_DETALLE,
  DATATABLE_COLUMNS_LISTA_ITEMS,
  DATATABLE_LISTA_ITEMS2,
  DATATABLE_INV_INVENTARIO,
  DATATABLE_DC_COMPRA,
  DATATABLE_TRAZABILIDAD,
  DATATABLE_ARTICULO,
  DATATABLE_APARTADO,
  DATATABLE_CATEGORIAS,
  DATATABLE_USUARIOS,
  DATATABLE_MARCAS,
  DATATABLE_PROVEEDORES,
  DATATABLE_CLIENTES,
  DATATABLE_FACTURA,
  DATATABLE_COTIZACION,
  DATATABLE_LISTA_CLIENTE,
  DATATABLE_LISTA_ITEMS,
  DATATABLE_COTIZACION_DETALLE,
  DATATABLE_BODEGAS,
  DATATABLE_COLUMNS_LISTA_CREDITOS,
  DATATABLE_EXSITENCIA_INVENTARIO,
  DATATABLE_COLUMNS_LISTA_ITEMS_BODEGA,
  DATATABLE_CLIENTES_REPORTE,
  DATATABLE_CLIENTES_HISTORIAL,
  DATATABLE_SERIES,
  DATATABLE_GASTOS,
};
